import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/landing/shape-1.png'
import _imports_1 from '@/assets/images/landing/shape-2.png'


const _hoisted_1 = {
  class: "our-team-area pt-125 position-relative z-1",
  id: "ourteam"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "our-team-single-item" }
const _hoisted_4 = { class: "team-img" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "team-content d-flex justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4 mb-lg-5\" data-v-10be513e><div class=\"section-title ms-0 text-start mw-630 mb-0\" data-v-10be513e><span class=\"top-title\" data-v-10be513e><span data-v-10be513e>Our Team</span></span><h2 data-v-10be513e> Introducing Our Exceptional Team. Meet the Minds Driving Our Success </h2></div><div class=\"team-controller d-flex gap-3\" data-v-10be513e><div class=\"controller-icon prev\" data-v-10be513e><i class=\"ri-arrow-left-line\" data-v-10be513e></i></div><div class=\"controller-icon next\" data-v-10be513e><i class=\"ri-arrow-right-line\" data-v-10be513e></i></div></div></div>", 1)),
      _createVNode(_component_Swiper, {
        slidesPerView: 1,
        spaceBetween: 25,
        centeredSlides: false,
        preventClicks: true,
        loop: true,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        navigation: {
          nextEl: '.prev',
          prevEl: '.next',
        },
        pagination: {
          el: '.swiper-pagination-top-selling',
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1199: {
            slidesPerView: 3,
          },
          1440: {
            slidesPerView: 3,
          },
          1600: {
            slidesPerView: 3,
          },
        },
        modules: _ctx.modules,
        class: "team-slide"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, {
              key: team.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("img", {
                      src: team.image,
                      alt: "team"
                    }, null, 8, _hoisted_5)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h3", null, _toDisplayString(team.name), 1),
                      _createElementVNode("span", null, _toDisplayString(team.designation), 1)
                    ]),
                    _cache[0] || (_cache[0] = _createElementVNode("ul", { class: "ps-0 mb-0 list-unstyled d-flex flex-wrap gap-3" }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "https://www.facebook.com/",
                          target: "_blank",
                          class: "text-decoration-none fs-20 text-primary"
                        }, [
                          _createElementVNode("i", { class: "ri-facebook-fill" })
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "https://www.twitter.com/",
                          target: "_blank",
                          class: "text-decoration-none fs-20 text-primary"
                        }, [
                          _createElementVNode("i", { class: "ri-twitter-x-line" })
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          href: "https://www.linkedin.com/",
                          target: "_blank",
                          class: "text-decoration-none fs-20 text-primary"
                        }, [
                          _createElementVNode("i", { class: "ri-linkedin-fill" })
                        ])
                      ])
                    ], -1))
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules"])
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("img", {
      src: _imports_0,
      class: "shape shape-3",
      alt: "shape"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("img", {
      src: _imports_1,
      class: "shape shape-4",
      alt: "shape"
    }, null, -1))
  ]))
}